import { css } from 'linaria';
import { strictBreakpoints } from '../../media';

export const greyBgWrapper = css`
	background-color: var(--background-secondary);
`;
export const yellowBrWrapper = css`
	background-color: var(--brand-primary);
`;
export const blackBgWrapper = css`
	background-color: var(--brand-secondary);
`;
export const containerFullWidthStyles = css`
	padding: 0;
`;
export const containerWithMarginTopStyles = css`
	margin-top: 80px;
	${strictBreakpoints.onlyTablet} {
		margin-top: 64px;
	}
	${strictBreakpoints.onlyMobile} {
		margin-top: 40px;
	}
`;
export const containerMobileDark = css`
	${strictBreakpoints.onlyMobile} {
		padding: 40px 16px;
		margin-top: 40px;
		background: var(--background-accent);
	}
`;
export const containerWithMarginBottomStyles = css`
	margin-bottom: 80px;
	${strictBreakpoints.onlyTablet} {
		margin-bottom: 64px;
	}
	${strictBreakpoints.onlyMobile} {
		margin-bottom: 40px;
	}
`;
export const breadCrumbsStyles = css`
	margin: 8px 0 24px;
`;
export const wrapperStyles = css`
	color: var(--text-primary);
`;
